import script from "./FloatingMenuModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingMenuModal.vue?vue&type=script&setup=true&lang=js"

import "./FloatingMenuModal.vue?vue&type=style&index=0&id=4833ffef&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4833ffef"]])

export default __exports__